module.exports = __webpack_public_path__ + "static/media/cadastro.4178135c.svg";